<template>
  <v-btn color="#635dff" @click="$emit('click')" class="custom-button">
    <span class="button-text">{{ text }}</span>
    <v-img :src="iconSrc" class="custom-icon"></v-img>
  </v-btn>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "Келесіге өту",
    },
    iconSrc: {
      type: String,
      default: require("@/assets/next-arrow.svg"),
    },
  },
};
</script>

<style scoped>
.custom-button {
  font-size: 18px;
  font-weight: bold;
  text-transform: none;
  border-radius: 18px;
  display: flex;
  margin: 0 auto;
  height: 50px !important;
  color: white !important;
  width: 200px !important;
}
.custom-button:hover {
  background-color: #5148d8 !important;
}
.custom-icon {
  width: 20px;
  height: 25px;
  margin-left: 8px;
  margin-top: 2px;
}
.button-text {
  width: 135px;
}
</style>
